import theme from "../../styles/theme";

const driversCustomCardStyles = {
  // 158: [1],
  // 238: 2,
  // 161: 1,
  // 162: 5,
  // 152: 2,
};

export const getStyleId = (driverId) => {
  return driversCustomCardStyles[driverId] || null;
};

const cardStyles = [
  //HARDCODE but ok for now
  {
    id: 1,
    description: "League Champion",
    style: `
        box-shadow: 0 0 9px 0px rgb(212 175 55 / 99%), 0 0 8px rgb(212 175 55 / 48%);
        border: solid 2px ${theme.colors.gold}4D;
        background-color: ${theme.colors.gold}1A;
      `,
  },
  {
    id: 2,
    description: "League P2",
    style: `
        border: solid 2px ${theme.colors.silver}4d;
        background-color: ${theme.colors.silver}30;
      `,
  },
  {
    id: 3,
    description: "League P3",
    style: `
        border: solid 2px ${theme.colors.bronze}4D;
        background-color: ${theme.colors.bronze}1A;
    `,
  },
  {
    id: 5,
    description: "League Special",
    style: `
      background-image:   repeating-linear-gradient(
        45deg,
        ${theme.colors.gold}4D 0px,
        ${theme.colors.gold}33 2px,
        transparent 2px,
        transparent 40px
      )
    `,
  },
  {
    id: 999,
    description: "Test",
    style: `
        background: repeating-linear-gradient(45deg, rgb(255 0 0 / 12%) 0, rgb(255 0 0 / 12%) 30px, transparent 30px, transparent 60px);
      `,
  },
];

export const getStyleByCardStyleId = (cardStyleIds) => {
  const ids = Array.isArray(cardStyleIds) ? cardStyleIds : [cardStyleIds];
  return ids.map((id) => cardStyles.find((style) => style.id === id)?.style ?? "").join("\n");
};
